import { useEffect, useState } from "react";
import { News } from "@/models/database/news/News.model";
import { useTenantNews } from "./useTenantNews";

export const useNewsBySlugs = (slugs: string[]) => {
  const { data: allNews, loading, error } = useTenantNews();
  const [filteredNews, setFilteredNews] = useState<News[]>([]);

  useEffect(() => {
    if (allNews && slugs.length > 0) {
      const matchedNews = allNews.filter((news) => slugs.includes(news.slug));
      setFilteredNews(matchedNews);
    }
  }, [allNews, slugs]);

  return {
    data: filteredNews,
    loading,
    error,
  };
};
